import React from "react";

function formatDraftTime(date) {
  if (!date) return "";
  try {
    return date.toLocaleString();
  } catch (e) {
    return "";
  }
}

export default function DraftSavedAt({ date, className = "" }) {
  if (!date) return null;

  return (
    <div className={className} style={{ fontSize: "12px", color: "#6c757d" }}>
      Draft saved at {formatDraftTime(date)}
    </div>
  );
}

